<template>
    <div class="content">
        <Aside :menus="menus" ></Aside>
        <div class="content-c">
         <router-view :key="$route.fullPath"/>

        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Aside from "@/components/Aside.vue";

export default {
    name: "",
    components: {
        Aside
    },
    data() {
        return {
            menus: [
                { icon: 'xs1', name: "学时情况", path: "/studyTime/network" },
                { icon: 'xs2', name: "学时补录", path: "/studyTime/supplement" },
            ]
        };
    },
    created() {
        
    },
    computed: {

    },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.content {
    padding: 20px 0;
    display: flex;

    .content-c {
        background: #FFFFFF;
        padding: 20px;
        flex: 1;
        margin-left: 20px;
    }
}
</style>